import './ResizeManager';
import './ScrollManager';
import { DOM_CONTENT_LOADED, LOAD, MODAL_TOGGLE, REVEALS } from 'core/Events';

import Cart from 'components/Cart';

import AbstractView from 'views/AbstractView';
// import Password from 'views/Password';
import LoginRegister from 'views/LoginRegister';
import Account from 'views/Account';
import Home from 'views/Home';
import About from 'views/About';
import Product from 'views/Product';

import EmitterManager from './EmitterManager';
import gsap from 'gsap';
import { createCookie, readCookie } from 'helpers/Cookies';

class AppManager {
  constructor() {
    this.bind();
    window.addEventListener(DOM_CONTENT_LOADED, this.preInitialize);
    window.addEventListener(LOAD, this.handleLoad);
    EmitterManager.on(REVEALS, this.handleReveal);
    $(document.body).on('click', '.js-scroll-to', this.handleScrollTo);
  }

  bind() {
    this.preInitialize = this.preInitialize.bind(this);
    this.initialize = this.initialize.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.handleReveal = this.handleReveal.bind(this);
    this.handleScrollTo = this.handleScrollTo.bind(this);
  }

  handleLoad() {
    if (this.view?.enter) {
      this.view.enter();
    }

    const newsletterShouldShow = readCookie('newsletter-next-page') === 'true';

    if (newsletterShouldShow) {
      EmitterManager.emit(MODAL_TOGGLE, 'modal-newsletter');
    }

    createCookie('newsletter-next-page', 'true', 1, '/');
  }

  preInitialize() {
    Promise.all([...document.querySelectorAll('[data-page-fetch]')].map(($pageFetch) => {
      const url = $pageFetch.dataset.pageFetch;
      return fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const dom = new DOMParser().parseFromString(html, 'text/html');
          const $target = dom.querySelector('.page');
          if ($target) {
            $pageFetch.innerHTML = $target.innerHTML;
          }
        });
    })).then(this.initialize);
  }

  initialize() {
    this.viewId = document.body.dataset.template;

    this.initializeViews();
    this.initializeGlobals();
    this.initializeComponents();
  }

  initializeViews() {
    switch (this.viewId) {
      // case 'password':
      //   this.view = new Password({
      //     $element: document.body.querySelector('.password'),
      //   });
      //   this.view.initialize();
      //   break;
      case 'index':
        this.view = new Home({ $element: document.body });
        break;
      case 'customers-login':
      case 'customers-register':
        this.view = new LoginRegister({ $element: document.body });
        break;
      case 'customers-addresses':
      case 'customers-account':
        this.view = new Account({ $element: document.body });
        break;
      case 'page-about':
        this.view = new About({ $element: document.body });
        break;
      case 'product':
      case 'product-le-collagene':
      case 'product-essentiel-peau':
      case 'product-l-essentiel-cheveux':
      case 'product-l-hydratant':
      case 'product-le-collagene-ecorecharge':
      case 'product-le-collagene-matcha':
        this.view = new Product({ $element: document.body });
        break;
      default:
        this.view = new AbstractView({ $element: document.body });
        break;
    }
  }

  initializeGlobals() {
    const REDIRECT_PATH = '/account';
    const selector = '#create_customer, form[action$="/account"][method="post"]';
    const $forms = [...document.querySelectorAll(selector)];

    $forms.forEach(($form) => {
      const $redirect = document.createElement('input');
      $redirect.setAttribute('name', 'return_to');
      $redirect.setAttribute('type', 'hidden');
      $redirect.value = REDIRECT_PATH;
      $form.appendChild($redirect);
    });
  }

  initializeComponents() {
    this.cart = new Cart({
      $element: document.body,
    });
  }

  handleScrollTo(event) {
    event.preventDefault();
    const id = event.currentTarget.getAttribute('href');
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: id,
        offsetY: $('.header').height(),
      },
    });
  }

  handleReveal($target) {
    if (!$target) return;

    const $reveals = [...$target.querySelectorAll('.reveal')];

    if ($reveals.length === 0) return;

    gsap
      .timeline()
      .to($reveals, 1, { opacity: 1, ease: 'cubic.out', stagger: 0.2 }, 0)
      .to($reveals, 1.5, { y: 0, ease: 'expo.out', stagger: 0.2 }, 0)
      .add(() => $reveals.forEach(($reveal) => $reveal.classList.remove('reveal')))
      .set($reveals, { clearProps: 'opacity,transform' });
  }
}

export default new AppManager();
